const AppraiseRoutes = [
    {
        path: 'myAppraise',
        name: 'myAppraise',
        component: () => import('@/views/Appraise/MyAppraise/myAppraise'), // 我的绩效-待办
        meta: {
            title: 'myPerformanceTodo',
            keepAlive: false,
        }
    },
    {
        path: 'myAppraiseQuery',
        name: 'myAppraiseQuery',
        component: () => import('@/views/Appraise/MyAppraise/myAppraiseQy'), // 我的绩效-绩效查询
        meta: {
            title: 'myPerformanceQuery',
            keepAlive: false,
        }
    },
    {
        path: 'functionHistoryList',
        name: 'functionHistoryList',
        component: () => import('@/views/Appraise/TeamAppraise/appraiseQueryList/functionHistoryList'), // 考核查询-查看职能历史单据
        meta: {
            title: 'AppraisalQuery'
        }
    },
    {
        path: 'salesHistoryList',
        name: 'salesHistoryList',
        component: () => import('@/views/Appraise/TeamAppraise/appraiseQueryList/salesHistoryList'), // 考核查询-查看销售/市场历史单据
        meta: {
            title: 'AppraisalQuery'
        }
    },
    {
        path: 'viewTargetKPI',
        name: 'viewTargetKPI',
        component: () => import('@/views/Appraise/MyAppraise/appraiseQueryList/viewTargetKPI'), // 职能考核目标查看kpi
        meta: {
            title: 'viewFunctionAppraisalObjectives'
        }
    },
    {
        path: 'viewTargetSTI',
        name: 'viewTargetSTI',
        component: () => import('@/views/Appraise/MyAppraise/appraiseQueryList/viewTargetSTI'), // 职能考核目标查看STI
        meta: {
            title: 'viewFunctionAppraisalObjectives'
        }
    },
    {
        path: 'viewTargetKPIAndSTI',
        name: 'viewTargetKPIAndSTI',
        component: () => import('@/views/Appraise/MyAppraise/appraiseQueryList/viewTargetKPIAndSTI'), // 职能考核目标查看KPI+STI
        meta: {
            title: 'viewFunctionAppraisalObjectives'
        }
    },
    {
        path: 'personnelReviseGoalsKPI',
        name: 'personnelReviseGoalsKPI',
        component: () => import('@/views/Appraise/MyAppraise/appraiseQueryList/personnelReviseGoalsKPI'), // 职能考核目标修正KPI
        meta: {
            title: 'revisionOfFunctionalAssessmentObjectives'
        }
    },
    {
        path: 'personnelReviseGoalsSTI',
        name: 'personnelReviseGoalsSTI',
        component: () => import('@/views/Appraise/MyAppraise/appraiseQueryList/personnelReviseGoalsSTI'), // 职能考核目标修正STI
        meta: {
            title: 'revisionOfFunctionalAssessmentObjectives'
        }
    },
    {
        path: 'personnelReviseGoalsKPIAndSTI',
        name: 'personnelReviseGoalsKPIAndSTI',
        component: () => import('@/views/Appraise/MyAppraise/appraiseQueryList/personnelReviseGoalsKPIAndSTI'), // 职能考核目标修正KPI+STI
        meta: {
            title: 'revisionOfFunctionalAssessmentObjectives'
        }
    },
    {
        path: 'functionResultDetails',
        name: 'functionResultDetails',
        component: () => import('@/views/Appraise/MyAppraise/resultQueryList/functionResultDetails'), // 我的绩效-结果查询-详情
        meta: {
            title: 'myAppraise'
        }
    },
    {
        path: 'functionSetGoalsKPI',
        name: 'functionSetGoalsKPI',
        component: () => import('@/views/Appraise/MyAppraise/myTargetManageList/functionSetGoalsKPI'), // 职能考核目标设定KPI
        meta: {
            title: 'functionalAssessmentObjectiveSetting'
        }
    },
    {
        path: 'functionSetGoalsSTI',
        name: 'functionSetGoalsSTI',
        component: () => import('@/views/Appraise/MyAppraise/myTargetManageList/functionSetGoalsSTI'), // 职能考核目标设定STI
        meta: {
            title: 'functionalAssessmentObjectiveSetting'
        }
    },
    {
        path: 'functionSetGoalsKPIAndSTI',
        name: 'functionSetGoalsKPIAndSTI',
        component: () => import('@/views/Appraise/MyAppraise/myTargetManageList/functionSetGoalsKPIAndSTI'), // 职能考核目标设定KPI+STI
        meta: {
            title: 'functionalAssessmentObjectiveSetting'
        }
    },
    {
        path: 'personnelConfirmGoalsKPI',
        name: 'personnelConfirmGoalsKPI',
        component: () => import('@/views/Appraise/MyAppraise/myTargetManageList/personnelConfirmGoalsKPI'), // 职能考核目标确认KPI
        meta: {
            title: 'confirmationOfFunctionalAssessmentObjectives'
        }
    },
    {
        path: 'personnelConfirmGoalsSTI',
        name: 'personnelConfirmGoalsSTI',
        component: () => import('@/views/Appraise/MyAppraise/myTargetManageList/personnelConfirmGoalsSTI'), // 职能考核目标确认STI
        meta: {
            title: 'confirmationOfFunctionalAssessmentObjectives'
        }
    },
    {
        path: 'personnelConfirmGoalsKPIAndSTI',
        name: 'personnelConfirmGoalsKPIAndSTI',
        component: () => import('@/views/Appraise/MyAppraise/myTargetManageList/personnelConfirmGoalsKPIAndSTI'), // 职能考核目标确认KPI+STI
        meta: {
            title: 'confirmationOfFunctionalAssessmentObjectives'
        }
    },
    {
        path: 'appraiseTodo',
        name: 'appraiseTodo',
        component: () => import('@/views/Appraise/MyAppraise/appraiseDetails/appraiseTodo.vue'), // 职能考核评估
        meta: {
            title: 'functionalAssessment'
        }
    },
    {
        path: 'appraiseTodoSale',
        name: 'appraiseTodoSale',
        component: () => import('@/views/Appraise/MyAppraise/appraiseDetails/appraiseTodoSale.vue'), // 销售/市场考核评估KPI
        meta: {
            title: 'salesAndMarketAssessment'
        }
    },
    {
        path: 'appraiseTodoSaleSTI',
        name: 'appraiseTodoSaleSTI',
        component: () => import('@/views/Appraise/MyAppraise/appraiseDetails/appraiseTodoSaleSTI.vue'), // 销售/市场考核评估STI
        meta: {
            title: 'salesAndMarketAssessment'
        }
    },
    {
        path: 'appraiseTodoExecutive',
        name: 'appraiseTodoExecutive',
        component: () => import('@/views/Appraise/MyAppraise/appraiseDetails/appraiseTodoExecutive.vue'), // 高管考核评估确认
        meta: {
            title: 'seniorManagementAssessment'
        }
    },
    {
        path: 'comprehensiveAnnualResults',
        name: 'comprehensiveAnnualResults',
        component: () => import('@/views/Appraise/MyAppraise/comprehensiveAnnualResults'), // 年度综合结果
        meta: {
            title: 'resultQuery'
        }
    },
    {
        path: 'interviewAndIdpEdit',
        name: 'interviewAndIdpEdit',
        component: () => import('@/views/Appraise/MyAppraise/interviewAndIdpEdit'), // 面谈&IDP维护
        meta: {
            title: 'interviewAndIDPMaintenance'
        }
    },
    {
        path: 'teamAppraise',
        name: 'teamAppraise',
        component: () => import('@/views/Appraise/TeamAppraise/teamAppraise'), // 团队绩效-待办
        meta: {
            title: 'teamPerformanceTodo'
        }
    },
    {
        path: 'teamAppraiseQuery',
        name: 'teamAppraiseQuery',
        component: () => import('@/views/Appraise/TeamAppraise/teamAppraiseQy'), // 团队绩效-绩效查询
        meta: {
            title: 'teamPerformanceQuery'
        }
    },
    {
        path: 'teamTargetEdit',
        name: 'teamTargetEdit',
        component: () => import('@/views/Appraise/TeamAppraise/teamTargetEdit'), // 团队绩效-部门目标-新增、编辑
        meta: {
            title: 'departmentObjectiveMaintenance'
        }
    },
    {
        path: 'teamTargetDetail',
        name: 'teamTargetDetail',
        component: () => import('@/views/Appraise/TeamAppraise/teamTargetDetail'), // 团队绩效-部门目标-查看详情
        meta: {
            title: 'departmentObjectiveDetails'
        }
    },
    {
        path: 'companyTargetManage',
        name: 'companyTargetManage',
        component: () => import('@/views/Appraise/CompanyTargetManage/companyTargetManage'), // 公司目标管理
        meta: {
            title: 'compTargetManagement',
            keepAlive: true
        }
    },
    {
        path: 'targetManageEdit',
        name: 'targetManageEdit',
        component: () => import('@/views/Appraise/CompanyTargetManage/targetManageEdit'), // 公司目标管理-目标管理-新增、编辑
        meta: {
            title: 'compTargetManagement'
        }
    },
    {
        path: 'fillInActual',
        name: 'fillInActual',
        component: () => import('@/views/Appraise/CompanyTargetManage/fillInActual'), // 公司目标管理-评分管理-填写实际值
        meta: {
            title: 'compTargetManagement'
        }
    },
    {
        path: 'targetManageDetail',
        name: 'targetManageDetail',
        component: () => import('@/views/Appraise/CompanyTargetManage/targetManageDetail'), // 公司目标管理-目标管理-详情
        meta: {
            title: 'compTargetManagement'
        }
    },
    {
        path: 'setSpecialTarget',
        name: 'setSpecialTarget',
        component: () => import('@/views/Appraise/CompanyTargetManage/setSpecialTarget'), // 公司目标管理-目标管理-设置特殊目标
        meta: {
            title: 'compTargetManagement'
        }
    },
    {
        path: 'specialPersonActual',
        name: 'specialPersonActual',
        component: () => import('@/views/Appraise/CompanyTargetManage/specialPersonActual'), // 公司目标管理-评分管理-特殊目标实际值
        meta: {
            title: 'compTargetManagement'
        }
    },
    {
        path: 'scoreManageDetail',
        name: 'scoreManageDetail',
        component: () => import('@/views/Appraise/CompanyTargetManage/scoreManageDetail'), // 公司目标管理-评分管理-详情
        meta: {
            title: 'compTargetManagement'
        }
    },
    {
        path: 'appraiseInfoMaintain',
        name: 'appraiseInfoMaintain',
        component: () => import('@/views/Appraise/AppraiseInfoMaintain/appraiseInfoMaintain'), // 考核信息维护
        meta: {
            title: 'assessmentInformationMaintenance'
        }
    },
    {
        path: 'personChangeList',
        name: 'personChangeList',
        component: () => import('@/views/Appraise/AppraiseInfoMaintain/personChangeList'), // 考核信息维护-人员变化情况
        meta: {
            title: 'assessmentInformationMaintenance'
        }
    },
    {
        path: 'appraiseInfoUnlock',
        name: 'appraiseInfoUnlock',
        component: () => import('@/views/Appraise/AppraiseInfoUnlock/appraiseInfoUnlock.vue'), // 考核信息解锁
        meta: {
            title: 'unlockAppraisalInformation'
        }
    },
    {
        path: 'targetManage',
        name: 'targetManage',
        component: () => import('@/views/Appraise/TargetManage/targetManage'), // 目标管理
        meta: {
            title: 'targetManagement',
            keepAlive: true
        }
    },
    {
        path: 'importProgressDetails',
        name: 'importProgressDetails',
        component: () => import ('@/views/Appraise/TargetManage/importProgressDetails'), // 目标管理-导入进度详情页
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'salesTargetSettingKPI',
        name: 'salesTargetSettingKPI',
        component: () => import('@/views/Appraise/TargetManage/salesTargetSettingList/salesTargetSettingKPI'), // 目标管理-销售类(目标设置)-KPI
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'salesTargetSettingSTI',
        name: 'salesTargetSettingSTI',
        component: () => import('@/views/Appraise/TargetManage/salesTargetSettingList/salesTargetSettingSTI'), // 目标管理-销售类(目标设置)-STI
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'salesTargetEditKPI',
        name: 'salesTargetEditKPI',
        component: () => import('@/views/Appraise/TargetManage/salesTargetEditList/salesTargetEditKPI'), // 目标管理-销售类(目标修改)-KPI
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'salesTargetEditSTI',
        name: 'salesTargetEditSTI',
        component: () => import('@/views/Appraise/TargetManage/salesTargetEditList/salesTargetEditSTI'), // 目标管理-销售类(目标修改)-STI
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'salesTargetOriginPreviewKPI',
        name: 'salesTargetOriginPreviewKPI',
        component: () => import('@/views/Appraise/TargetManage/salesTargetEditList/salesTargetOriginPreviewKPI'), // 目标管理-销售类(目标修改)-原考核方案-KPI
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'salesTargetOriginPreviewSTI',
        name: 'salesTargetOriginPreviewSTI',
        component: () => import('@/views/Appraise/TargetManage/salesTargetEditList/salesTargetOriginPreviewSTI'), // 目标管理-销售类(目标修改)-原考核方案-STI
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'seniorExecutiveTargetList',
        name: 'seniorExecutiveTargetList',
        component: () => import('@/views/Appraise/TargetManage/seniorExecutiveTargetList/seniorExecutiveTargetList'), // 目标管理-高管类(目标)
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'seniorExecutiveTargetImportList',
        name: 'seniorExecutiveTargetImportList',
        component: () => import ('@/views/Appraise/TargetManage/seniorExecutiveTargetImportList'), // 目标管理-高管类(目标)导入进度详情页
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'seniorExecutiveTarget',
        name: 'seniorExecutiveTarget',
        component: () => import('@/views/Appraise/TargetManage/seniorExecutiveTargetList/seniorExecutiveTarget'), // 目标管理-维护目标 修改目标 
        meta: {
            title: 'targetManagement'
        }
    },
    {
        path: 'scoreManage',
        name: 'scoreManage',
        component: () => import('@/views/Appraise/ScoreManage/scoreManage'), // 评分管理
        children: [
            {
                path: 'scoreAppeal',
                name: 'scoreAppeal',
                component: () => import('@/views/Appraise/MyAppraise/saleAppeal.vue'),
                meta: {
                    title: 'determineResult',
                    // keepAlive: true,
                }
            },
            {
                path: 'scoreTab',
                name: 'scoreTab',
                component: () => import('@/views/Appraise/ScoreManage/tabs.vue'),
                meta: {
                    title: 'scoreManagement',
                    // keepAlive: true,
                }
            },
            {
                path: 'salesScoreSTI',
                name: 'salesScoreSTI',
                component: () => import('@/views/Appraise/ScoreManage/salesScoreSTI.vue'),
                meta: {
                    title: 'scoreManagement',
                    // keepAlive: true,
                }
            },
            {
                path: 'appraiseResult',
                name: 'appraiseResult',
                component: () => import('@/views/Appraise/ScoreManage/appraiseResult.vue'),
                meta: {
                    title: 'result',
                    // keepAlive: true,
                }
            },
        ],
        meta: {
            keepAlive: true,
            title: 'scoreManagement'
        }
    },
    {
        path:'scoreManage/STIDetail',
        name:'STIDetail',
        component:()=>import('@/views/Appraise/ScoreManage/STIDetail.vue'),
        meta:{
            title:'STIDetail'
        }
    },
    {
        path:'scoreManage/executiveImportDetail',
        name:'executiveImportDetail',
        component:()=>import('@/views/Appraise/ScoreManage/executiveImportDetail.vue'),
        meta:{
            title:'executiveImportDetail'
        }
    },
    {
        path: 'executiveEvaluation',
        name: 'executiveEvaluation',
        component: () => import('@/views/Appraise/ScoreManage/executiveEvaluation'), // 高管考核 维护/修改结果
        meta: {
            title: 'scoreManagement'
        }
    },
    {
        path: 'appraisalInfoQuery',
        name: 'appraisalInfoQuery',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/appraisalInfoQuery'), // 考核信息查询
        meta: {
            title: 'assessmentInformationInquiry',
            keepAlive: true,
        }
    },
    {
        path: 'interviewAndIdpDetails',
        name: 'interviewAndIdpDetails',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/interviewAndIdpDetails'), // 面谈&IDP-详情
        meta: {
            title: 'interviewAndIDPDetails'
        }
    },
    {
        path: 'previewSalesTargetKPI',
        name: 'previewSalesTargetKPI',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/previewSalesTargetKPI'), // 考核信息查询-销售目标-KPI
        meta: {
            title: 'salesAndMarketAssessmentObjectives'
        }
    },
    {
        path: 'previewSalesTargetSTI',
        name: 'previewSalesTargetSTI',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/previewSalesTargetSTI'), // 考核信息查询-销售目标-STI
        meta: {
            title: 'salesAndMarketAssessmentObjectives'
        }
    },
    {
        path: 'previewSeniorExecutive',
        name: 'previewSeniorExecutive',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/previewSeniorExecutive'), // 考核信息查询-高管目标
        meta: {
            title: 'executiveAssessmentObjectives'
        }
    },
    {
        path: 'confirmSalesTargetKPI',
        name: 'confirmSalesTargetKPI',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/confirmSalesTargetKPI'), // 销售目标确认-KPI
        meta: {
            title: 'salesTargetConfirmation'
        }
    },
    {
        path: 'confirmSalesTargetSTI',
        name: 'confirmSalesTargetSTI',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/confirmSalesTargetSTI'), // 销售目标确认-STI
        meta: {
            title: 'salesTargetConfirmation'
        }
    },
    {
        path: 'appraisalQueryFunctionDetail',
        name: 'appraisalQueryFunctionDetail',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/appraisalQueryFunctionDetail'), // 考核信息查询-考核查询-职能-详情
        meta: {
            title: 'assessmentInformationInquiry'
        }
    },
    {
        path: 'appraisalQuerySalesDetail',
        name: 'appraisalQuerySalesDetail',
        component: () => import('@/views/Appraise/AppraisalInfoQuery/appraisalQuerySalesDetail'), // 考核信息查询-考核查询-销售-详情
        meta: {
            title: 'assessmentInformationInquiry'
        }
    },
    {
        path: 'salesUnlock',
        name: 'salesUnlock',
        component: () => import('@/views/Appraise/SalesUnlock/salesUnlock'), // 销售解锁
        meta: {
            title: 'salesUnlock'
        }
    },
    {
        path: 'functionAppraisalCycleMaintenance',
        name: 'functionAppraisalCycleMaintenance',
        component: () => import('@/views/Appraise/FunctionAppraisalCycleMaintenance'), // 职能考核周期维护
        meta: {
            title: 'functionAppraisalCycleMaintenance'
        }
    },
    {
        path: 'functionalPerformanceTargetImport',
        name: 'functionalPerformanceTargetImport',
        component: () => import('@/views/Appraise/FunctionalPerformanceTargetImport'), // 职能绩效目标导入
        meta: {
            title: 'functionalPerformanceTargetImport'
        }
    },
    {
        path: 'pipDetail',
        name: 'pipDetail',
        component: () => import('@/views/Appraise/Component/pipDetail'), // PIP详情
        meta: {
            title: 'pip'
        }
        
    }
]

export default AppraiseRoutes